import { createReducer } from 'Utils';
import TYPES from 'Catalog/types';

const initialState = {
  itemSelected: null,
  items: [],
  defaultOrderBy: null,
};

export default createReducer(initialState, {
  [TYPES.SELECT_ORDERBY]: (state, { item }) => ({
    ...state,
    itemSelected: { ...item },
  }),
  [TYPES.SET_DEFAULT_ORDERBY]: state => ({
    ...state,
    itemSelected: {
      ...state.defaultOrderBy,
    },
  }),
});
